var exports = {};
/*! dom-to-image-more 13-09-2024 */
(l => {
  let f = (() => {
      let e = 0;
      return {
        escape: function (e) {
          return e.replace(/([.*+?^${}()|[\]/\\])/g, "\\$1");
        },
        isDataUrl: function (e) {
          return -1 !== e.search(/^(data:)/);
        },
        canvasToBlob: function (t) {
          if (t.toBlob) return new Promise(function (e) {
            t.toBlob(e);
          });
          return (r => new Promise(function (e) {
            var t = u(r.toDataURL().split(",")[1]),
              n = t.length,
              o = new Uint8Array(n);
            for (let e = 0; e < n; e++) o[e] = t.charCodeAt(e);
            e(new Blob([o], {
              type: "image/png"
            }));
          }))(t);
        },
        resolveUrl: function (e, t) {
          var n = document.implementation.createHTMLDocument(),
            o = n.createElement("base"),
            r = (n.head.appendChild(o), n.createElement("a"));
          return n.body.appendChild(r), o.href = t, r.href = e, r.href;
        },
        getAndEncode: function (s) {
          let e = a.impl.urlCache.find(function (e) {
            return e.url === s;
          });
          e || (e = {
            url: s,
            promise: null
          }, a.impl.urlCache.push(e));
          null === e.promise && (a.impl.options.cacheBust && (s += (/\?/.test(s) ? "&" : "?") + new Date().getTime()), e.promise = new Promise(function (t) {
            let e = a.impl.options.httpTimeout,
              r = new XMLHttpRequest();
            if (r.onreadystatechange = function () {
              if (4 === r.readyState) if (300 <= r.status) n ? t(n) : l(`cannot fetch resource: ${s}, status: ` + r.status);else {
                let e = new FileReader();
                e.onloadend = function () {
                  t(e.result);
                }, e.readAsDataURL(r.response);
              }
            }, r.ontimeout = function () {
              n ? t(n) : l(`timeout of ${e}ms occured while fetching resource: ` + s);
            }, r.responseType = "blob", r.timeout = e, 0 < a.impl.options.useCredentialsFilters.length && (a.impl.options.useCredentials = 0 < a.impl.options.useCredentialsFilters.filter(e => 0 <= s.search(e)).length), a.impl.options.useCredentials && (r.withCredentials = !0), a.impl.options.corsImg && 0 === s.indexOf("http") && -1 === s.indexOf(window.location.origin)) {
              var i = "POST" === (a.impl.options.corsImg.method || "GET").toUpperCase() ? "POST" : "GET";
              r.open(i, (a.impl.options.corsImg.url || "").replace("#{cors}", s), !0);
              let t = !1,
                n = a.impl.options.corsImg.headers || {},
                o = (Object.keys(n).forEach(function (e) {
                  -1 !== n[e].indexOf("application/json") && (t = !0), r.setRequestHeader(e, n[e]);
                }), (e => {
                  try {
                    return JSON.parse(JSON.stringify(e));
                  } catch (e) {
                    l("corsImg.data is missing or invalid:" + e.toString());
                  }
                })(a.impl.options.corsImg.data || ""));
              Object.keys(o).forEach(function (e) {
                "string" == typeof o[e] && (o[e] = o[e].replace("#{cors}", s));
              }), r.send(t ? JSON.stringify(o) : o);
            } else r.open("GET", s, !0), r.send();
            let n;
            function l(e) {
              console.error(e), t("");
            }
            a.impl.options.imagePlaceholder && (i = a.impl.options.imagePlaceholder.split(/,/)) && i[1] && (n = i[1]);
          }));
          return e.promise;
        },
        uid: function () {
          return "u" + ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4) + e++;
        },
        delay: function (n) {
          return function (t) {
            return new Promise(function (e) {
              setTimeout(function () {
                e(t);
              }, n);
            });
          };
        },
        asArray: function (t) {
          var n = [],
            o = t.length;
          for (let e = 0; e < o; e++) n.push(t[e]);
          return n;
        },
        escapeXhtml: function (e) {
          return e.replace(/%/g, "%25").replace(/#/g, "%23").replace(/\n/g, "%0A");
        },
        makeImage: function (o) {
          return "data:," !== o ? new Promise(function (e, t) {
            let n = new Image();
            a.impl.options.useCredentials && (n.crossOrigin = "use-credentials"), n.onload = function () {
              window && window.requestAnimationFrame ? window.requestAnimationFrame(function () {
                e(n);
              }) : e(n);
            }, n.onerror = t, n.src = o;
          }) : Promise.resolve();
        },
        width: function (e) {
          var t = i(e, "width");
          if (!isNaN(t)) return t;
          var t = i(e, "border-left-width"),
            n = i(e, "border-right-width");
          return e.scrollWidth + t + n;
        },
        height: function (e) {
          var t = i(e, "height");
          if (!isNaN(t)) return t;
          var t = i(e, "border-top-width"),
            n = i(e, "border-bottom-width");
          return e.scrollHeight + t + n;
        },
        getWindow: t,
        isElement: r,
        isElementHostForOpenShadowRoot: function (e) {
          return r(e) && null !== e.shadowRoot;
        },
        isShadowRoot: n,
        isInShadowRoot: o,
        isHTMLElement: function (e) {
          return e instanceof t(e).HTMLElement;
        },
        isHTMLCanvasElement: function (e) {
          return e instanceof t(e).HTMLCanvasElement;
        },
        isHTMLInputElement: function (e) {
          return e instanceof t(e).HTMLInputElement;
        },
        isHTMLImageElement: function (e) {
          return e instanceof t(e).HTMLImageElement;
        },
        isHTMLLinkElement: function (e) {
          return e instanceof t(e).HTMLLinkElement;
        },
        isHTMLScriptElement: function (e) {
          return e instanceof t(e).HTMLScriptElement;
        },
        isHTMLStyleElement: function (e) {
          return e instanceof t(e).HTMLStyleElement;
        },
        isHTMLTextAreaElement: function (e) {
          return e instanceof t(e).HTMLTextAreaElement;
        },
        isShadowSlotElement: function (e) {
          return o(e) && e instanceof t(e).HTMLSlotElement;
        },
        isSVGElement: function (e) {
          return e instanceof t(e).SVGElement;
        },
        isSVGRectElement: function (e) {
          return e instanceof t(e).SVGRectElement;
        },
        isDimensionMissing: function (e) {
          return isNaN(e) || e <= 0;
        }
      };
      function t(e) {
        e = e ? e.ownerDocument : void 0;
        return (e ? e.defaultView : void 0) || window || l;
      }
      function n(e) {
        return e instanceof t(e).ShadowRoot;
      }
      function o(e) {
        return null != e && void 0 !== e.getRootNode && n(e.getRootNode());
      }
      function r(e) {
        return e instanceof t(e).Element;
      }
      function i(t, n) {
        if (t.nodeType === c) {
          let e = m(t).getPropertyValue(n);
          if ("px" === e.slice(-2)) return e = e.slice(0, -2), parseFloat(e);
        }
        return NaN;
      }
    })(),
    r = (() => {
      let o = /url\(['"]?([^'"]+?)['"]?\)/g;
      return {
        inlineAll: function (t, o, r) {
          if (!e(t)) return Promise.resolve(t);
          return Promise.resolve(t).then(n).then(function (e) {
            let n = Promise.resolve(t);
            return e.forEach(function (t) {
              n = n.then(function (e) {
                return i(e, t, o, r);
              });
            }), n;
          });
        },
        shouldProcess: e,
        impl: {
          readUrls: n,
          inline: i
        }
      };
      function e(e) {
        return -1 !== e.search(o);
      }
      function n(e) {
        for (var t, n = []; null !== (t = o.exec(e));) n.push(t[1]);
        return n.filter(function (e) {
          return !f.isDataUrl(e);
        });
      }
      function i(n, o, t, e) {
        return Promise.resolve(o).then(function (e) {
          return t ? f.resolveUrl(e, t) : e;
        }).then(e || f.getAndEncode).then(function (e) {
          return n.replace((t = o, new RegExp(`(url\\(['"]?)(${f.escape(t)})(['"]?\\))`, "g")), `$1${e}$3`);
          var t;
        });
      }
    })(),
    e = {
      resolveAll: function () {
        return t().then(function (e) {
          return Promise.all(e.map(function (e) {
            return e.resolve();
          }));
        }).then(function (e) {
          return e.join("\n");
        });
      },
      impl: {
        readAll: t
      }
    };
  function t() {
    return Promise.resolve(f.asArray(document.styleSheets)).then(function (e) {
      let n = [];
      return e.forEach(function (t) {
        var e = Object.getPrototypeOf(t);
        if (Object.prototype.hasOwnProperty.call(e, "cssRules")) try {
          f.asArray(t.cssRules || []).forEach(n.push.bind(n));
        } catch (e) {
          console.error("domtoimage: Error while reading CSS rules from " + t.href, e.toString());
        }
      }), n;
    }).then(function (e) {
      return e.filter(function (e) {
        return e.type === CSSRule.FONT_FACE_RULE;
      }).filter(function (e) {
        return r.shouldProcess(e.style.getPropertyValue("src"));
      });
    }).then(function (e) {
      return e.map(t);
    });
    function t(t) {
      return {
        resolve: function () {
          var e = (t.parentStyleSheet || {}).href;
          return r.inlineAll(t.cssText, e);
        },
        src: function () {
          return t.style.getPropertyValue("src");
        }
      };
    }
  }
  let n = {
    inlineAll: function t(e) {
      if (!f.isElement(e)) return Promise.resolve(e);
      return n(e).then(function () {
        return f.isHTMLImageElement(e) ? o(e).inline() : Promise.all(f.asArray(e.childNodes).map(function (e) {
          return t(e);
        }));
      });
      function n(o) {
        let e = ["background", "background-image"],
          t = e.map(function (t) {
            let e = o.style.getPropertyValue(t),
              n = o.style.getPropertyPriority(t);
            return e ? r.inlineAll(e).then(function (e) {
              o.style.setProperty(t, e, n);
            }) : Promise.resolve();
          });
        return Promise.all(t).then(function () {
          return o;
        });
      }
    },
    impl: {
      newImage: o
    }
  };
  function o(n) {
    return {
      inline: function (e) {
        if (f.isDataUrl(n.src)) return Promise.resolve();
        return Promise.resolve(n.src).then(e || f.getAndEncode).then(function (t) {
          return new Promise(function (e) {
            n.onload = e, n.onerror = e, n.src = t;
          });
        });
      }
    };
  }
  let s = {
      copyDefaultStyles: !0,
      imagePlaceholder: void 0,
      cacheBust: !1,
      useCredentials: !1,
      useCredentialsFilters: [],
      httpTimeout: 30000,
      styleCaching: "strict",
      corsImg: void 0,
      adjustClonedNode: void 0
    },
    a = {
      toSvg: d,
      toPng: function (e, t) {
        return i(e, t).then(function (e) {
          return e.toDataURL();
        });
      },
      toJpeg: function (e, t) {
        return i(e, t).then(function (e) {
          return e.toDataURL("image/jpeg", (t ? t.quality : void 0) || 1);
        });
      },
      toBlob: function (e, t) {
        return i(e, t).then(f.canvasToBlob);
      },
      toPixelData: function (t, e) {
        return i(t, e).then(function (e) {
          return e.getContext("2d").getImageData(0, 0, f.width(t), f.height(t)).data;
        });
      },
      toCanvas: i,
      impl: {
        fontFaces: e,
        images: n,
        util: f,
        inliner: r,
        urlCache: [],
        options: {}
      }
    },
    c = (exports = a, ("undefined" != typeof Node ? Node.ELEMENT_NODE : void 0) || 1),
    m = (void 0 !== l ? l.getComputedStyle : void 0) || ("undefined" != typeof window ? window.getComputedStyle : void 0) || globalThis.getComputedStyle,
    u = (void 0 !== l ? l.atob : void 0) || ("undefined" != typeof window ? window.atob : void 0) || globalThis.atob;
  function d(e, r) {
    let t = a.impl.util.getWindow(e);
    var n = r = r || {};
    void 0 === n.copyDefaultStyles ? a.impl.options.copyDefaultStyles = s.copyDefaultStyles : a.impl.options.copyDefaultStyles = n.copyDefaultStyles, a.impl.options.imagePlaceholder = (void 0 === n.imagePlaceholder ? s : n).imagePlaceholder, a.impl.options.cacheBust = (void 0 === n.cacheBust ? s : n).cacheBust, a.impl.options.corsImg = (void 0 === n.corsImg ? s : n).corsImg, a.impl.options.useCredentials = (void 0 === n.useCredentials ? s : n).useCredentials, a.impl.options.useCredentialsFilters = (void 0 === n.useCredentialsFilters ? s : n).useCredentialsFilters, a.impl.options.httpTimeout = (void 0 === n.httpTimeout ? s : n).httpTimeout, a.impl.options.styleCaching = (void 0 === n.styleCaching ? s : n).styleCaching;
    let i = [];
    return Promise.resolve(e).then(function (e) {
      if (e.nodeType === c) return e;
      var t = e,
        n = e.parentNode,
        o = document.createElement("span");
      return n.replaceChild(o, t), o.append(e), i.push({
        parent: n,
        child: t,
        wrapper: o
      }), o;
    }).then(function (e) {
      return function l(t, s, r, u) {
        let e = s.filter;
        if (t === h || f.isHTMLScriptElement(t) || f.isHTMLStyleElement(t) || f.isHTMLLinkElement(t) || null !== r && e && !e(t)) return Promise.resolve();
        return Promise.resolve(t).then(n).then(o).then(function (e) {
          return c(e, a(t));
        }).then(i).then(function (e) {
          return d(e, t);
        });
        function n(e) {
          return f.isHTMLCanvasElement(e) ? f.makeImage(e.toDataURL()) : e.cloneNode(!1);
        }
        function o(e) {
          return s.adjustClonedNode && s.adjustClonedNode(t, e, !1), Promise.resolve(e);
        }
        function i(e) {
          return s.adjustClonedNode && s.adjustClonedNode(t, e, !0), Promise.resolve(e);
        }
        function a(e) {
          return f.isElementHostForOpenShadowRoot(e) ? e.shadowRoot : e;
        }
        function c(n, e) {
          let o = t(e),
            r = Promise.resolve();
          if (0 !== o.length) {
            let t = m(i(e));
            f.asArray(o).forEach(function (e) {
              r = r.then(function () {
                return l(e, s, t, u).then(function (e) {
                  e && n.appendChild(e);
                });
              });
            });
          }
          return r.then(function () {
            return n;
          });
          function i(e) {
            return f.isShadowRoot(e) ? e.host : e;
          }
          function t(t) {
            if (f.isShadowSlotElement(t)) {
              let e = t.assignedNodes();
              if (e && 0 < e.length) return e;
            }
            return t.childNodes;
          }
        }
        function d(u, a) {
          return !f.isElement(u) || f.isShadowSlotElement(a) ? Promise.resolve(u) : Promise.resolve().then(e).then(t).then(n).then(o).then(function () {
            return u;
          });
          function e() {
            function o(e, t) {
              t.font = e.font, t.fontFamily = e.fontFamily, t.fontFeatureSettings = e.fontFeatureSettings, t.fontKerning = e.fontKerning, t.fontSize = e.fontSize, t.fontStretch = e.fontStretch, t.fontStyle = e.fontStyle, t.fontVariant = e.fontVariant, t.fontVariantCaps = e.fontVariantCaps, t.fontVariantEastAsian = e.fontVariantEastAsian, t.fontVariantLigatures = e.fontVariantLigatures, t.fontVariantNumeric = e.fontVariantNumeric, t.fontVariationSettings = e.fontVariationSettings, t.fontWeight = e.fontWeight;
            }
            function e(e, t) {
              let n = m(e);
              n.cssText ? (t.style.cssText = n.cssText, o(n, t.style)) : (y(s, e, n, r, t), null === r && (["inset-block", "inset-block-start", "inset-block-end"].forEach(e => t.style.removeProperty(e)), ["left", "right", "top", "bottom"].forEach(e => {
                t.style.getPropertyValue(e) && t.style.setProperty(e, "0px");
              })));
            }
            e(a, u);
          }
          function t() {
            let s = f.uid();
            function t(r) {
              let i = m(a, r),
                l = i.getPropertyValue("content");
              if ("" !== l && "none" !== l) {
                let e = u.getAttribute("class") || "",
                  t = (u.setAttribute("class", e + " " + s), document.createElement("style"));
                function n() {
                  let e = `.${s}:` + r,
                    t = (i.cssText ? n : o)();
                  return document.createTextNode(e + `{${t}}`);
                  function n() {
                    return `${i.cssText} content: ${l};`;
                  }
                  function o() {
                    let e = f.asArray(i).map(t).join("; ");
                    return e + ";";
                    function t(e) {
                      let t = i.getPropertyValue(e),
                        n = i.getPropertyPriority(e) ? " !important" : "";
                      return e + ": " + t + n;
                    }
                  }
                }
                t.appendChild(n()), u.appendChild(t);
              }
            }
            [":before", ":after"].forEach(function (e) {
              t(e);
            });
          }
          function n() {
            f.isHTMLTextAreaElement(a) && (u.innerHTML = a.value), f.isHTMLInputElement(a) && u.setAttribute("value", a.value);
          }
          function o() {
            f.isSVGElement(u) && (u.setAttribute("xmlns", "http://www.w3.org/2000/svg"), f.isSVGRectElement(u)) && ["width", "height"].forEach(function (e) {
              let t = u.getAttribute(e);
              t && u.style.setProperty(e, t);
            });
          }
        }
      }(e, r, null, t);
    }).then(r.disableEmbedFonts ? Promise.resolve(e) : p).then(g).then(function (t) {
      r.bgcolor && (t.style.backgroundColor = r.bgcolor);
      r.width && (t.style.width = r.width + "px");
      r.height && (t.style.height = r.height + "px");
      r.style && Object.keys(r.style).forEach(function (e) {
        t.style[e] = r.style[e];
      });
      let e = null;
      "function" == typeof r.onclone && (e = r.onclone(t));
      return Promise.resolve(e).then(function () {
        return t;
      });
    }).then(function (e) {
      let n = r.width || f.width(e),
        o = r.height || f.height(e);
      return Promise.resolve(e).then(function (e) {
        return e.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), new XMLSerializer().serializeToString(e);
      }).then(f.escapeXhtml).then(function (e) {
        var t = (f.isDimensionMissing(n) ? " width=\"100%\"" : ` width="${n}"`) + (f.isDimensionMissing(o) ? " height=\"100%\"" : ` height="${o}"`);
        return `<svg xmlns="http://www.w3.org/2000/svg"${(f.isDimensionMissing(n) ? "" : ` width="${n}"`) + (f.isDimensionMissing(o) ? "" : ` height="${o}"`)}><foreignObject${t}>${e}</foreignObject></svg>`;
      }).then(function (e) {
        return "data:image/svg+xml;charset=utf-8," + e;
      });
    }).then(function (e) {
      for (; 0 < i.length;) {
        var t = i.pop();
        t.parent.replaceChild(t.child, t.wrapper);
      }
      return e;
    }).then(function (e) {
      return a.impl.urlCache = [], (() => {
        h && (document.body.removeChild(h), h = null), v && clearTimeout(v), v = setTimeout(() => {
          v = null, w = {};
        }, 20000);
      })(), e;
    });
  }
  function i(r, i) {
    return d(r, i = i || {}).then(f.makeImage).then(function (e) {
      var t = "number" != typeof i.scale ? 1 : i.scale,
        n = ((e, t) => {
          let n = i.width || f.width(e),
            o = i.height || f.height(e);
          return f.isDimensionMissing(n) && (n = f.isDimensionMissing(o) ? 300 : 2 * o), f.isDimensionMissing(o) && (o = n / 2), (e = document.createElement("canvas")).width = n * t, e.height = o * t, i.bgcolor && ((t = e.getContext("2d")).fillStyle = i.bgcolor, t.fillRect(0, 0, e.width, e.height)), e;
        })(r, t),
        o = n.getContext("2d");
      return o.msImageSmoothingEnabled = !1, o.imageSmoothingEnabled = !1, e && (o.scale(t, t), o.drawImage(e, 0, 0)), n;
    });
  }
  let h = null;
  function p(n) {
    return e.resolveAll().then(function (e) {
      var t;
      return "" !== e && (t = document.createElement("style"), n.appendChild(t), t.appendChild(document.createTextNode(e))), n;
    });
  }
  function g(e) {
    return n.inlineAll(e).then(function () {
      return e;
    });
  }
  function y(e, t, i, l, n) {
    let s = a.impl.options.copyDefaultStyles ? ((t, e) => {
        var n,
          o = (e => ("relaxed" !== t.styleCaching ? e : e.filter((e, t, n) => 0 === t || t === n.length - 1)).join(">"))(e = (e => {
            var t = [];
            do {
              if (e.nodeType === c) {
                var n = e.tagName;
                if (t.push(n), E.includes(n)) break;
              }
            } while (e = e.parentNode);
            return t;
          })(e));
        {
          if (w[o]) return w[o];
          e = ((e, t) => {
            let n = e.body;
            do {
              var o = t.pop(),
                o = e.createElement(o);
              n.appendChild(o), n = o;
            } while (0 < t.length);
            return n.textContent = "\u200B", n;
          })((n = (() => {
            if (h) return h.contentWindow;
            t = document.characterSet || "UTF-8", e = (e = document.doctype) ? (`<!DOCTYPE ${s(e.name)} ${s(e.publicId)} ` + s(e.systemId)).trim() + ">" : "", (h = document.createElement("iframe")).id = "domtoimage-sandbox-" + f.uid(), h.style.visibility = "hidden", h.style.position = "fixed", document.body.appendChild(h);
            var e,
              t,
              n = h,
              o = "domtoimage-sandbox";
            try {
              return n.contentWindow.document.write(e + `<html><head><meta charset='${t}'><title>${o}</title></head><body></body></html>`), n.contentWindow;
            } catch (e) {}
            var r = document.createElement("meta");
            r.setAttribute("charset", t);
            try {
              var i = document.implementation.createHTMLDocument(o),
                l = (i.head.appendChild(r), e + i.documentElement.outerHTML);
              return n.setAttribute("srcdoc", l), n.contentWindow;
            } catch (e) {}
            return n.contentDocument.head.appendChild(r), n.contentDocument.title = o, n.contentWindow;
            function s(e) {
              var t;
              return e ? ((t = document.createElement("div")).innerText = e, t.innerHTML) : "";
            }
          })()).document, e), n = ((e, t) => {
            let n = {},
              o = e.getComputedStyle(t);
            return f.asArray(o).forEach(function (e) {
              n[e] = "width" === e || "height" === e ? "auto" : o.getPropertyValue(e);
            }), n;
          })(n, e);
          var r = e;
          do {
            var i = r.parentElement;
            null !== i && i.removeChild(r), r = i;
          } while (r && "BODY" !== r.tagName);
          return w[o] = n;
        }
      })(e, t) : {},
      u = n.style;
    f.asArray(i).forEach(function (e) {
      var t,
        n = i.getPropertyValue(e),
        o = s[e],
        r = l ? l.getPropertyValue(e) : void 0;
      u.getPropertyValue(e) || (n !== o || l && n !== r) && (o = i.getPropertyPriority(e), r = u, n = n, o = o, t = 0 <= ["background-clip"].indexOf(e = e), o ? (r.setProperty(e, n, o), t && r.setProperty("-webkit-" + e, n, o)) : (r.setProperty(e, n), t && r.setProperty("-webkit-" + e, n)));
    });
  }
  let v = null,
    w = {},
    E = ["ADDRESS", "ARTICLE", "ASIDE", "BLOCKQUOTE", "DETAILS", "DIALOG", "DD", "DIV", "DL", "DT", "FIELDSET", "FIGCAPTION", "FIGURE", "FOOTER", "FORM", "H1", "H2", "H3", "H4", "H5", "H6", "HEADER", "HGROUP", "HR", "LI", "MAIN", "NAV", "OL", "P", "PRE", "SECTION", "SVG", "TABLE", "UL", "math", "svg", "BODY", "HEAD", "HTML"];
})(exports);
//# sourceMappingURL=dom-to-image-more.min.js.map
export default exports;